module.exports = __webpack_public_path__ + "static/img/Desktop_HomePage_Logo.60cb9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop/landing/2024/Desktop_HomePage_Logo.png
// module id = b0Fj
// module chunks = 1